import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_MY_PERSONS ({ commit }) {
    const query = `query userPersonen($order_by: UserPersonUserSort) {
      userPersonen(order_by: $order_by) {
        nodes {
          userPersonId
          anrede
          email
          firma
          hausNr
          land
          name
          oeffentlicheHand
          ort
          plz
          postfach
          strasse
          telefon
          uid
          userPersonId
          vorname
          zusatz
          adresse
          createdUserEmail
        }
      }
    }`

    const variables = {
      order_by: {
        vorname: 'ASC',
        name: 'ASC',
        ort: 'ASC',
        strasse: 'ASC',
        hausNr: 'ASC'
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_PERSONS', data.data.userPersonen.nodes)
    }

    return data
  },
  async GET_PERSON_BY_ID ({ commit }, { personId, includeOrganisation }) {
    const query = `query userPersonById($userPersonId: Int!, $includeOrganisation: Boolean!) {
      userPersonById(userPersonId: $userPersonId, includeOrganisation: $includeOrganisation) {
        anrede
        email
        firma
        hausNr
        land
        name
        oeffentlicheHand
        ort
        plz
        postfach
        strasse
        telefon
        uid
        userPersonId
        vorname
        zusatz
        adresse
        landBezeichnung
      }
    }`

    const variables = {
      userPersonId: Number(personId),
      includeOrganisation
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_PERSON_BY_ID', data.data.userPersonById)
    }

    return data
  },
  async SAVE_PERSON ({ commit }, { isContactPerson, formData }) {
    const {
      anrede,
      vorname,
      name,
      firma,
      zusatz,
      uid,
      oeffentlicheHand,
      strasse,
      hausNr,
      postfach,
      plz,
      ort,
      telefon,
      email,
      land
    } = formData

    const query = `mutation userPersonCreate($input: UserPersonenCreateInput!) {
      userPersonCreate(input: $input) {
        anrede
        email
        firma
        hausNr
        land
        name
        oeffentlicheHand
        ort
        plz
        postfach
        strasse
        telefon
        uid
        userPersonId
        vorname
        zusatz
        adresse
        landBezeichnung
      }
    }`

    const variables = {
      input: {
        anrede,
        vorname,
        name,
        firma,
        zusatz,
        uid,
        oeffentlicheHand,
        strasse,
        hausNr,
        postfach,
        plz,
        ort,
        telefon,
        email,
        land
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      const { userPersonCreate: person } = data.data

      commit('SET_PERSON', person)

      if (isContactPerson === true) {
        commit('application/SET_APPLICATION_PERSON_CONTACT_ID', person.userPersonId, { root: true })
      } else if (isContactPerson === false) {
        commit('application/SET_APPLICATION_PERSON_ID', person.userPersonId, { root: true })
      }
    }

    return data
  },
  async UPDATE_PERSON ({ commit }, formData) {
    const {
      userPersonId,
      anrede,
      vorname,
      name,
      firma,
      zusatz,
      uid,
      oeffentlicheHand,
      strasse,
      hausNr,
      postfach,
      plz,
      ort,
      telefon,
      email,
      land
    } = formData

    const query = `mutation userPersonUpdate($input: UserPersonenUpdateInput!) {
      userPersonUpdate(input: $input) {
        anrede
        email
        firma
        hausNr
        land
        name
        oeffentlicheHand
        ort
        plz
        postfach
        strasse
        telefon
        uid
        userPersonId
        vorname
        zusatz
        adresse
        landBezeichnung
      }
    }`

    const variables = {
      input: {
        userPersonId,
        anrede,
        vorname,
        name,
        firma,
        zusatz,
        uid,
        oeffentlicheHand,
        strasse,
        hausNr,
        postfach,
        plz,
        ort,
        telefon,
        email,
        land
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('UPDATE_PERSON', data.data.userPersonUpdate)
    }

    return data
  },
  async DELETE_PERSON ({ commit }, personId) {
    const query = `mutation userPersonDelete($userPersonId: Int!) {
      userPersonDelete(userPersonId: $userPersonId) {
        ok
      }
    }`

    const variables = {
      userPersonId: personId
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('DELETE_PERSON', personId)
    }

    return data
  }
}
